import { UnloadingDockPattern } from "@/utils/factory/constants";

/**
 * Single型の検収ページを表示するかを工場の荷下ろし形態によって判定する
 */
export const shouldDisplaySingleVersion = (unloadingDockPattern: string) => {
  return unloadingDockPattern !== UnloadingDockPattern.Linear;
};
